import React, { useContext } from 'react';
import './Layout.css';
import plusIcon from './../../../assets/images/general-icons/plus.svg';
import bellIcon from './../../../assets/images/general-icons/bell.svg';
import { NavLink } from 'react-router-dom';
import { RootContext } from '../../../hoc/RootContext/RootContext';
import styles from './Layout.module.css';
import { FiSettings } from 'react-icons/fi';
import { AiOutlineProfile, AiOutlineClockCircle } from 'react-icons/ai';
import { useIntl } from 'react-intl';

const classNames = require('classnames');

export default ({ children }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const { isAdminMenuOpen, currentUser } = useContext(RootContext);

  if (!currentUser) {
    return null;
  }

  const { fname, lname } = currentUser;

  return (
    <div className={classNames(isAdminMenuOpen ? '' : styles.menuToggle, 'd-flex')}>
      <section className={classNames(styles.leftCol, 'bg-white')}>
        <nav className={styles.nav}>
          <ul className='p-0'>
            <li className='data-username'>
              <NavLink to="/admin/settings" className={styles.usernameLink}>
                <span className={styles.fNavIconProfile}>{fname[0]}</span>
                <span className={styles.menuDescription}> {fname} {lname} </span>
                <img className='ml-auto' src={bellIcon} alt="" /></NavLink>
            </li>
            <li className='data-new-profile'>
              <NavLink to="/admin/profile/new">
                <span className={`${styles.fNavIcon} `}><AiOutlineProfile /></span>
                <span className={styles.menuDescription}> {t('Layout.createNewProfile')} </span>
                <img src={plusIcon} alt="" className='ml-auto' />
              </NavLink>
            </li>
            <li className='data-recent-profiles'>
              <NavLink to="/admin/profiles/recent">
                <span className={`${styles.fNavIcon}`}><AiOutlineClockCircle /></span>
                <span className={styles.menuDescription}> {t('Layout.recent')} </span><span></span></NavLink>
            </li>
            <li className='data-company-settings'>
              <NavLink to="/admin/company_settings">
                <span className={`${styles.fNavIcon}`}><FiSettings /></span>
                <span className={styles.menuDescription}> {t('Layout.companySettings')} </span>
                <span></span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </section>
      <section className={classNames(styles.rightCol, 'flex-grow-1 overflow-auto p-0')}>
        {children}
      </section>
    </div>
  );
};
